/**
 * Default avatar images and SVG data URLs
 */

/**
 * Attractive unisex avatar with gradient background and modern design
 * Uses brand colors: teal/green gradient (#22907d to #378F94)
 */
export const DEFAULT_USER_AVATAR = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cdefs%3E%3ClinearGradient id='avatarGrad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' stop-color='%2322907d'/%3E%3Cstop offset='100%25' stop-color='%23378F94'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='60' cy='60' r='60' fill='url(%23avatarGrad)'/%3E%3Ccircle cx='60' cy='45' r='16' fill='%23FFFFFF' opacity='0.95'/%3E%3Cpath d='M 28 90 C 28 75, 40 68, 60 68 C 80 68, 92 75, 92 90 L 92 105 L 28 105 Z' fill='%23FFFFFF' opacity='0.95'/%3E%3C/svg%3E";

